import {
	GET_SCHEDULES,
	GET_SCHEDULES_ERROR,
	GET_SCHEDULES_SUCCESS,
} from '../../../constants';

export const getSchedulesReducer = (state, actions) => {
	switch (actions.type) {
		case GET_SCHEDULES:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_SCHEDULES_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_SCHEDULES_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				schedules: actions.payload,
			};
		default:
			return state;
	}
};
